import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Anticipation.css";

const Anticipation = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const navigate = useNavigate();

  const [hasAccess, setHasAccess] = useState(null);
  const [deviceError, setDeviceError] = useState(false);

  // ================= DEVICE CHECK =================
  // Phone மட்டும் block.
  // iPad / Lenovo M11 / Android Tablet / Laptop / Desktop allow.

  const isMobilePhone = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    // iPhone / iPod மட்டும் phone
    const isApplePhone = /iPhone|iPod/i.test(ua);

    // Android Phone மட்டும்
    // Android Tablet-ல் பொதுவாக "Mobile" இருக்காது
    const isAndroidPhone =
      /Android/i.test(ua) && /Mobile/i.test(ua);

    // Windows Phone
    const isWindowsPhone = /Windows Phone/i.test(ua);

    return (
      isApplePhone ||
      isAndroidPhone ||
      isWindowsPhone
    );
  };

  // ================= ACCESS CHECK =================
  useEffect(() => {
    const email = localStorage.getItem("user_email");

    if (!email) {
      navigate("/");
      return;
    }

    axios
      .get(`/check-access?email=${email}&test=working_memory`)
      .then((res) => {
        if (res.data.allowed) {
          setHasAccess(true);
        } else {
          setHasAccess(false);
        }
      })
      .catch(() => navigate("/"));
  }, [navigate]);

  // ================= LOADING =================
  if (hasAccess === null) {
    return <div>Loading...</div>;
  }

  // ================= ACCESS DENIED =================
  if (hasAccess === false) {
    return (
      <div className="access-denied-container">
        <h2>🚫 Access Denied</h2>

        <p>
          You don't have access to this test
        </p>

        <button onClick={() => navigate("/")}>
          Go Back
        </button>
      </div>
    );
  }

  // ================= START TEST =================
  const handleStartTest = () => {
    // Phone என்றால் மட்டும் popup
    if (isMobilePhone()) {
      setDeviceError(true);
      return;
    }

    // Tablet / Laptop / Desktop
    navigate("/anticipation/play");
  };

return (
  <div className="rg-login-wrapper">

    {/* ✅ Mobile block popup */}
    {deviceError && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.65)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999
        }}
      >
        <div
          style={{
            background: "white",
            borderRadius: "16px",
            padding: "40px 36px",
            textAlign: "center",
            maxWidth: "340px",
            width: "90%",
            boxShadow: "0 8px 32px rgba(0,0,0,0.3)"
          }}
        >
          <div
            style={{
              fontSize: "56px",
              marginBottom: "16px"
            }}
          >
            📱
          </div>

          <h2
            style={{
              margin: "0 0 10px",
              fontSize: "22px",
              color: "#1a1a2e"
            }}
          >
            Mobile Not Supported
          </h2>

          <p
            style={{
              color: "#666",
              fontSize: "15px",
              lineHeight: "1.6",
              marginBottom: "28px"
            }}
          >
            This test requires a larger screen.
            <br />
            Please use a tablet, laptop, or desktop computer.
          </p>

          <button
            onClick={() => setDeviceError(false)}
            style={{
              padding: "12px 32px",
              background: "#f0f0f0",
              color: "#444",
              border: "none",
              borderRadius: "10px",
              fontSize: "15px",
              cursor: "pointer",
              width: "100%"
            }}
          >
            OK
          </button>
        </div>
      </div>
    )}

  

      {/* ================= HEADER SECTION ================= */}
      <div className="reaction-header-card">

        <h2 className="reaction-title">Anticipation Test</h2>

        <p className="reaction-subtitle">
          Anticipation measures your ability to
          <strong> predict what will happen next </strong>
          based on visual cues and movement patterns.
          It trains the brain to
          <strong> "Observe → Predict → React."</strong>
        </p>

        <div className="reaction-pill">
          Test type: <strong>Prediction → Decision making</strong>
        </div>

        <hr className="reaction-divider" />

        {/* ================= WHY SECTION ================= */}
        <div className="reaction-why-card">

          <h3 className="why-title">
            Why anticipation matters in sport
          </h3>

          <p className="why-description">
            In sports, elite athletes don't just react — they anticipate.
            Whether it's predicting a pass, reading an opponent's move,
            or timing a shot, anticipation gives players a critical
            advantage by reducing reaction time and improving decisions.
          </p>

          <div className="why-tags">
            <span>Faster decision making</span>
            <span>Better game intelligence</span>
            <span>Improved reaction timing</span>
            <span>Predict opponent movement</span>
            <span>Enhanced performance under pressure</span>
          </div>

        </div>
      </div>

      {/* ================= HOW GAME WORKS ================= */}
      <div className="how-card">

        <h2 className="how-title">How the game works</h2>

        <ul className="how-list">
          <li>A moving object or pattern will appear on the screen.</li>
          <li>It may disappear or change direction suddenly.</li>
          <li>Your task is to <strong>predict where it will appear next</strong>.</li>
          <li>Select or click the correct predicted position.</li>
          <li>You will get <strong>multiple rounds</strong> and your accuracy and timing will be recorded.</li>
          <li>Faster and correct predictions increase your score.</li>
        </ul>

        <p className="how-note">
          ⚠️ This test works on laptop / desktop only. Mobile is not supported.
        </p>

      </div>

      {/* ================= START TEST ================= */}
      <div className="start-test-section">

        <h2>Ready to test your anticipation skills?</h2>

        {/* ✅ handleStartTest checks device before navigating */}
        <button
          className="start-test-btn"
          onClick={handleStartTest}
        >
          Start Test
        </button>

      </div>

    </div>
  );
};

export default Anticipation;
